import React, { useEffect, useState } from 'react'
import { ENVS, getEnv } from '@adsk/acs-sc-web-platform-api'
import { NapiClient } from '@adsk/napi-api-client'
import { type Config } from './types'
import defaultConfig from './defaultConfig'
import prodConfig from './prodConfig'

const withConfig = (Component: JSX.ElementType) =>
	function ConfigHOC(props: any): JSX.Element {
		const [config, setConfig] = useState<Config>({})
		useEffect(() => {
			async function fetchConfig(): Promise<void> {
				try {
					await NapiClient.getClientConfig().then((config) => {
						setConfig(config)
					})
				} catch (e) {
					if (getEnv() === ENVS.PRODUCTION) {
						setConfig(prodConfig)
					} else {
						setConfig(defaultConfig)
					}
				}
			}
			void fetchConfig()
		}, [])

		return <Component {...props} config={config} />
	}

export default withConfig
